import Component from '@glimmer/component';

/**
 * @param {Number}  number
 * @param {Boolean} shouldDisplayCheckmark
 */
// eslint-disable-next-line ember/no-empty-glimmer-component-classes
export default class CircleNumberOrCheckmark extends Component {}
